import React, { useEffect, useRef } from "react";

/**
 * Elemento contenedor de las opciones del submenu de navegación
 * @param {any} children 
 * @returns {JSX.Element} tabpanel
 */
const tabpanel = ({ children, ariaLabel }) => {
    return (
        <div
            className={'plCasa-tabpanel py-3'}
            role="tablist"
            aria-label={ariaLabel}
        >
            <div className="container">
                <ul className="w-100  d-sm-flex" role="presentation">
                    {children}
                </ul>
            </div>
        </div>
    )
}

/**
 * opción del submenu de navegación
 * @param {string} title - texto del botón
 * @param {Function} onClick - funciónd el botón
 * @param {boolean} active - indica si el botón esta activo
 * @returns {JSX.Element} tab
 */
const Tab = ({ title, onClick, active, tabId, panelId, onKeyDown }) => {
    const ref = useRef(null);

    useEffect(() => {
        if (active && ref.current) {
            ref.current.focus();
        }
    }, [active]);


    if (!title) return null;
    return (
        <>
            <li role="presentation">
                <button
                    ref={ref}
                    role="tab"
                    id={tabId}
                    aria-selected={active}
                    aria-controls={panelId}
                    //tabIndex={active ? 0 : -1}
                    className={` ${active ? "current" : ""} focusable-red tab mr-sm-4 d-block  mx-auto `}
                    onClick={() => onClick && onClick()}
                    onKeyDown={onKeyDown}
                >
                    {title}
                </button>
            </li>
        </>
    )
}

/**
 * Objeto que retorna los componentes que conforman el subMenu de opciones en PLAN CASA
 */
export const PlanCasaNav = {
    tabpanel,
    tab : Tab
};
